import GatewayList from './GatewayList'
export default GatewayList;